export default "__VITE_ASSET__CiLHH01d__"